<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.push('/staff/sellTeam')"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <!-- 团队信息 -->
    <div class="color0063ea mgt-20 f16 fw-600 mgb-15">团队信息</div>
    <el-descriptions title="" border>
      <el-descriptions-item label="团队名称">{{
        dataInfo.departmentName ? dataInfo.departmentName : "- -"
      }}</el-descriptions-item>
      <el-descriptions-item label="组长">{{
        dataInfo.groupName
      }}</el-descriptions-item>
      <el-descriptions-item label="团队成员数">{{
        dataInfo.departmentNum
      }}</el-descriptions-item>
      <el-descriptions-item label="组内充值订单数（笔）">{{
        topStatForm.orderNum
      }}</el-descriptions-item>
      <el-descriptions-item label="充值金额（赠送/实付）">{{
        topStatForm.orderMoney +
          "（" +
          topStatForm.giveMoney +
          "/" +
          topStatForm.payMoney +
          "）"
      }}</el-descriptions-item>
      <el-descriptions-item label="团队创建时间">{{
        dataInfo.createTime
      }}</el-descriptions-item>
      <el-descriptions-item label="说明">{{
        dataInfo.remark ? dataInfo.remark : "- -"
      }}</el-descriptions-item>
    </el-descriptions>
    <!-- 成员信息 -->
    <div class="color0063ea mgt-20 f16 fw-600 mgb-15">成员信息</div>
    <div class="flex aic jcsb mgb-15">
      <div>
        <el-button @click="addStaff">添加成员</el-button>
        <el-button @click="delStaff">移除成员</el-button>
        <el-button @click="exportBtn">导出</el-button>
      </div>
      <div class="flex aic">
        <span class="mgr-15">成员状态</span>
        <el-select class="mgr-10" v-model="staffStatus" placeholder="请选择">
          <el-option label="正常" value="0"> </el-option>
          <el-option label="移除团队" value="1"> </el-option>
        </el-select>
        <el-button @click="getList()">查询</el-button>
        <el-button
          @click="
            staffStatus = '';
            getList();
          "
          >重置</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="name" label="员工姓名"> </el-table-column>
      <el-table-column prop="phone" label="员工电话"> </el-table-column>
      <el-table-column prop="orderNum" label="充值订单数"> </el-table-column>
      <el-table-column prop="payMoney" label="充值总金额">
        <template slot-scope="scope">
          <span
            v-text="(scope.row.giveMoney + scope.row.payMoney).toFixed(2)"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="giveMoney" label="充值赠送金额"> </el-table-column>
      <el-table-column prop="payMoney" label="充值实付金额"> </el-table-column>
      <el-table-column prop="address" label="成员状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.salesStatus == 0
                ? '正常'
                : scope.row.salesStatus == 1
                ? '移除团队'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="加入团队时间">
      </el-table-column>
      <el-table-column prop="createTime" label="移除团队时间">
        <template slot-scope="scope">
          <span
            v-text="scope.row.updateTime ? scope.row.updateTime : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDetail(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <!-- 添加成员弹框 -->
    <el-dialog
      title="添加成员"
      :visible.sync="addVisible"
      width="30%"
      center
      top="30vh"
    >
      <el-form ref="addForm" :rules="rules" :model="addForm" label-width="80px">
        <el-form-item label="类型" prop="type">
          <el-select filterable v-model="addForm.type" placeholder="请选择">
            <el-option label="组长" value="1"></el-option>
            <el-option label="员工" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="添加成员" prop="staff">
          <el-select
            filterable
            v-model="addForm.staff"
            placeholder="请选择成员"
          >
            <el-option
              v-for="(v, i) in userArr"
              :key="i"
              :label="v.name"
              :value="v.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="addStaffSure('addForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 导出弹框 -->
    <el-dialog
      title="导出"
      :visible.sync="exportVisible"
      width="30%"
      center
      top="30vh"
    >
      <el-form ref="exportForm" :model="exportForm" label-width="80px">
        <el-form-item label="成员状态">
          <el-select v-model="exportForm.salesStatus" placeholder="请选择">
            <el-option label="正常" value="0"></el-option>
            <el-option label="移除团队" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="exportVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="exportSureBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      staffStatus: "",
      tableData: [], // 表格数据
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 10, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      multipleSelection: [], // 多选数据
      addVisible: false, // 添加成员弹框显示隐藏
      addForm: {
        staff: "",
        type: "",
      }, // 添加表单数据
      rules: {
        staff: [
          {
            required: true,
            message: "请选择成员",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
      },
      userArr: [],
      dataInfo: {},
      exportVisible: false, // 导出弹框显示隐藏
      exportForm: {
        salesStatus: "",
      },
      topStatForm: {
        giveMoney: 0,
        orderMoney: 0,
        orderNum: 0,
        payMoney: 0,
      },
    };
  },
  created() {
    this.getInfo();

    this.getList();

    this.getTopStat();
  },
  methods: {
    getTopStat() {
      this.$api.sellTeam
        .teamStat({ teamId: this.$route.query.id })
        .then((res) => {
          if (res.code == 200 && res.data) {
            this.topStatForm = res.data;
          } else {
            this.topStatForm = {
              giveMoney: 0,
              orderMoney: 0,
              orderNum: 0,
              payMoney: 0,
            };
          }
        });
    },
    handleDetail(row) {
      this.$router.push({
        path: "/staff/staffDetail",
        query: {
          data: row,
          id: this.$route.query.id,
        },
      });
    },
    exportBtn() {
      this.exportForm.salesStatus = "";
      this.exportVisible = true;
    },
    exportSureBtn() {
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          this.$api.sellTeam
            .teamExport({
              salesStatus: this.exportForm.salesStatus
                ? this.exportForm.salesStatus
                : null,
              departmentId: this.$route.query.id,
            })
            .then((res) => {
              handleAlert("导出成功", "success");
              this.exportVisible = false;
              const link = document.createElement("a");
              link.style.display = "none";
              link.href = URL.createObjectURL(res);
              link.setAttribute("download", "团队成员.xls");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        })
        .catch(() => {
          return;
        });
    },
    delStaff() {
      if (this.multipleSelection.length !== 1) {
        handleAlert("请选择一条数据", "error");
        return;
      }
      handleConfirm("确认从团队移除该成员吗?", "info")
        .then(() => {
          this.$api.sellTeam
            .teamDelStaff({ id: this.multipleSelection[0].departmentSalesId })
            .then((res) => {
              if (res.code === 200) {
                handleAlert("移除成功", "success");
                this.getList();
                this.getInfo();
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    addStaffSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.userArr.forEach((v) => {
            if (this.addForm.staff == v.id) {
              this.addForm.salesName = v.name;
            }
          });
          handleConfirm("确认新增该成员吗?", "info")
            .then(() => {
              this.$api.sellTeam
                .teamAddStaff({
                  departmentId: this.$route.query.id,
                  salesId: this.addForm.staff,
                  salesName: this.addForm.salesName,
                  roleId: this.addForm.type,
                })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("新增成功", "success");
                    this.addVisible = false;
                    this.getList();
                    this.getInfo();
                    this.getUserPull();
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    addStaff() {
      this.addForm.staff = "";
      this.addForm.type = "";
      this.getUserPull();

      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
      this.addVisible = true;
    },
    // 团队详情
    getInfo() {
      this.$api.sellTeam
        .teamDetail({ id: this.$route.query.id })
        .then((res) => {
          if (res.code === 200) {
            this.dataInfo = res.data;
          }
        });
    },
    // 团队成员列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.sellTeam
        .teamStaffList({
          pageNum: this.page,
          pageSize: this.pageSize,
          departmentId: this.$route.query.id,
          salesStatus: this.staffStatus,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    getUserPull() {
      this.$api.zone.peoplePull().then((res) => {
        if (res.code === 200) {
          // this.userArr = res.data.list;
          this.userArr = res.data.list.filter((itemA) => {
            // b 数组中是否有与 itemA.name 相等的对象
            return !this.tableData.some(
              (itemB) => itemB.salesStatus == 0 && itemB.name === itemA.name
            );
          });
        }
      });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="scss" scoped></style>
